module.exports = __webpack_public_path__ + "img/4.7fe09c3c.jpg";